export const SCREEN_NAME = 'RECENTLY_VIEWED_GOODS';
